export interface IApiNicheSearch {
  Name: string;
  Type: string;
  SearchSetting: any;
}

export default class NicheSearch {
  name: string;
  type: string;
  searchSetting: any;

  constructor() {
    this.name = '';
    this.type = '';
    this.searchSetting = {};
  }

  static mappingObject(_niche: IApiNicheSearch): NicheSearch {
    const niche = new NicheSearch();
    niche.name = _niche.Name;
    niche.type = _niche.Type;
    niche.searchSetting = _niche.SearchSetting;
    return niche;
  }

  static mappingObjects(_niches: IApiNicheSearch[]): NicheSearch[] {
    const niches: NicheSearch[] = [];
    _niches.forEach(_niche => {
      const niche = NicheSearch.mappingObject(_niche);
      niches.push(niche);
    });
    return niches;
  }
}
